import React from "react";
import {
  AccessTime,
  AddLink,
  DateRange,
  ModeStandby,
  People,
  SocialDistance,
  TripOrigin,
} from "@mui/icons-material";
import { Badge } from "reactstrap";

export const WorkSessionsHeaders = [
  {
    name: "Date",
    key: "date",
    type: "date",
    icon: <DateRange fontSize="small" />,
  },
  {
    name: "Trip Name",
    key: "trip_id",
    type: "number",
    icon: <TripOrigin fontSize="small" />,
  },
  {
    name: "Employee Name",
    key: "user_name",
    type: "autocomplete",
    icon: <People fontSize="small" />,
  },
  {
    name: "Start Time",
    key: "formatted_start_time",
    type: "time",
    icon: <AccessTime fontSize="small" />,
  },
  {
    name: "End Time",
    key: "formatted_end_time",
    type: "time",
    icon: <AccessTime fontSize="small" />,
  },
  {
    name: "Distance",
    key: "distance_cover",
    type: "number",
    icon: <SocialDistance fontSize="small" />,
  },
  {
    name: "View Trip",
    key: "bank_branch",
    type: "autocomplete",
    icon: <Badge fontSize="small" />,
  },
];

export const monitoringpolicyHeader = [
  {
    name: "Scope",
    key: "scope_model",
    type: "autocomplete",
    icon: <ModeStandby fontSize="small" />,
  },
  {
    name: "Name",
    key: "scope_name",
    type: "autocomplete",
    icon: <People fontSize="small" />,
  },
  {
    name: "Checkpoint Threshold",
    key: "threshold_minutes",
    type: "number",
    icon: <AccessTime fontSize="small" />,
  }, 

   {
    name: "Trip Distance Threshold",
    key: "trip_distance_threshold",
    type: "number",
    icon: <SocialDistance fontSize="small" />,
  },

  {
    name: "Check-in Linked To Worksession",
    key: "is_linked_to_checkin",
    type: "boolean",
    icon: <AddLink fontSize="small" />,
  },
];

export const scopeName = [
  {
    id: 1,
    label: "Department",
  },
  {
    id: 2,
    label: "Designation",
  },
  {
    id: 3,
    label: "Role",
  },
  {
    id: 4,
    label: "User",
  },
];
